import React from 'react';
// import './App.css';
import StopwatchForm from './StopwatchForm';
import Header from './header';
import { Outlet } from 'react-router-dom';

function MainLayout() {


  return (
    <div className="App">
      <Header />
      <Outlet />
    </div>
  );
}

export default MainLayout;